<template>
  <div class="myTicket">
    <div class="cart orderList" :class="{isPublic: isPublic}">
      <h1 class="boxTitle mb15 notranslate">
        <router-link v-if="isPackage"
          :to="{ name: 'mypackage' }"
          class="btnMypackage">
          {{ locale.mypackage_history }}
        </router-link>
        {{locale.ticket_list}}
      </h1>
      <div class="ticketList">
        <div v-if="list && list.length === 0" class="noData">{{ locale.ticket_nodata }}</div>
        <router-link v-for="(item, index) in list"
          :key="index"
          :data-status="item.status"
          :to="{ name: 'myTicketDetail', params: { ...$route.params, guestTicketId: item.guestTicketId } }"
          class="ticketItem">
          <div class="left">
            <div class="itemStatus">
              {{ getTicketStatus(item.status).label }}
            </div>
            <div class="itemName">
              <span class="startat">
                [{{ getAvailableDate(item.startat, item.expireat) }}]
              </span>
              {{item.ticketName[lang]}}
            </div>
          </div>
          <div class="right">
            <div class="itemAction">
              {{ getTicketStatus(item.status).action }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'TicketList',
  props: [
  'lang',
  'ln',
  'locale',
  'isPublic'
  ],
  computed: {
    isPackage () {
      return this.$route.params.package
    },
    dateFormat () {
      return this.$store.getters['common/getDateFormat']
    }
  },
  async created () {
    await this.getTicketList()
  },
  data () {
    return {
      list: null
    }
  },
  methods: {
    async getTicketList () {
      this.$store.commit('loading', true)
      const res = await this.$store.dispatch('ticket/getTicketList')
      const ticketList = res && res.message
      if (ticketList) {
        this.list = ticketList.map(ticket => {
          return {
            ticketName: ticket.content.linkContent,
            psId: ticket.content.psId,
            guestTicketId: ticket.guestTicketId,
            // guestTicketId: '0388babe-d1e9-4542-91f7-7d0bc7ba4ac5', // LMS 테스트 가능한 uuid
            status: ticket.status,
            startat: ticket.startat,
            expireat: ticket.expireat,
            ticketUUID: ticket.ticketUUID // 에디터에서 패키지서비스를 티켓으로 생성했을 때의 UUID (타입이 티켓인 패키지서비스의 uuid)
          }
        })
      }
      this.$store.commit('loading', false)
      return res
    },
    getTicketStatus (status) {
      let statusLabel = status
      let ticketAction = status
      if (status === 'UNUSED') {
        statusLabel = this.locale.message_ticket_UNUSED
        ticketAction = this.locale.do_ticket_use
      } else if (status === 'USED') {
        statusLabel = this.locale.message_ticket_USED
        ticketAction = this.locale.do_ticket_history
      } else if (status === 'CANCELLED') {
        statusLabel = this.locale.message_ticket_CANCELLED
        ticketAction = this.locale.do_ticket_detail
      }
      return {
        label: statusLabel,
        action: ticketAction
      }
    },
    getAvailableDate (startAt, expireAt) {
      const start = moment(startAt)
      // const end = moment(expireAt)
      // const sameDate = start.isSame(end, 'day')

      const startStr = start.format(this.dateFormat.toUpperCase().replace('YYYY/', ''))
      // const endStr = sameDate ? '' : ` - ${end.format(this.dateFormat)}`

      // return `티켓 사용일: ${startStr}${endStr}`
      return startStr
    }
  }
}
</script>